//dependencies
import React, { useRef } from "react";
import { useResizeObserver } from "usehooks-ts";

import VerticalExpander from "../../../../../../components/AnimationWrappers/VerticalExpander";
import Button from "../../../../../../components/Button";
//components
import MarkdownReader from "../../../../../../components/MarkdownReader";
import Spacer from "../../../../../../components/Spacer";

// hooks
import useSavedPageState from "../../../../../../hooks/usePageSavedPageState";

//config
import Config from "../../../config";
//css
import css from "../SingleGoalInfo.module.scss";

type ExpandableGoalDescriptionProps = {
	descriptionMarkdown: string;
};

const ExpandableGoalDescription = ({ descriptionMarkdown }: ExpandableGoalDescriptionProps) => {
	const ref = useRef<HTMLDivElement>(null);
	const { height = 0 } = useResizeObserver<HTMLDivElement>({
		ref,
	});

	const {
		pageState: { descriptionExpanded = false },
		updatePageState,
	} = useSavedPageState({
		pageName: "goal_progress",
		schema: Config.savedQueryParametersSchema,
	});

	return (
		<div>
			<div>
				<VerticalExpander isExpanded={descriptionExpanded} closedHeight={64} className={css.goalDescription}>
					<div ref={ref}>
						<MarkdownReader markdownText={descriptionMarkdown} />
					</div>
				</VerticalExpander>
			</div>
			{height >= 64 ? (
				<div>
					<Spacer height={1} />
					<Button
						color="gray"
						size="micro"
						onClick={() => updatePageState({ descriptionExpanded: descriptionExpanded ? undefined : true })}
					>
						{descriptionExpanded ? "Read Less" : "Read More"}
					</Button>
				</div>
			) : null}
		</div>
	);
};

export default ExpandableGoalDescription;
